var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mainPane-container"
  }, [_c('div', {
    staticClass: "resume-embed-container slide-fade-up-grandchild"
  }, [_c('div', {
    staticClass: "resume-actions fade-in",
    staticStyle: {
      "--duration": "0.8s"
    }
  }, [_c('button', {
    staticClass: "resume-download-button",
    attrs: {
      "disabled": _vm.isDownloadingPdf
    },
    on: {
      "click": _vm.handleDownloadPdf
    }
  }, [_vm._v(" " + _vm._s(_vm.isDownloadingPdf ? "Preparing PDF..." : "Download PDF") + " ")])]), _c('div', {
    class: ['resume-embed-viewport', {
      'resume-embed-hidden': !_vm.isLoaded
    }, {
      'fade-in': _vm.isLoaded
    }],
    staticStyle: {
      "--duration": "1.8s"
    }
  }, [_c('iframe', {
    ref: "resumeEmbed",
    class: ['resume-embed', {
      'resume-embed-hidden': !_vm.isLoaded
    }, {
      'fade-in': _vm.isLoaded
    }],
    staticStyle: {
      "--duration": "1.8s"
    },
    attrs: {
      "src": "https://erikd7.github.io/resume/",
      "title": "Resume",
      "scrolling": "no"
    },
    on: {
      "load": _vm.handleLoad
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }